// extracted by mini-css-extract-plugin
export default {"navbarBackBtn":"navbar_navbarBackBtn__rfa8r","navbarNextBtn":"navbar_navbarNextBtn__9q5Dm"};